import { cssVar, mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

export const FeedPostAssetCarouselContainer = styled.div`
  overflow: hidden;
  min-width: var(--feed-post-slider-width);
  padding-bottom: ${cssVar('spacing-xl')};
  padding-left: ${cssVar('spacing-sm')};

  .image-card-item {
    min-height: 100%;

    > *,
    .image-card {
      height: 100%;
    }
  }

  .placeholder-card {
    width: min-content;
  }

  .image-card {
    min-width: 360px;
  }

  ${mediaQuery(
    'sm',
    css`
      .image-card-item {
        .image-card {
          /* Make sure it is small enough to fit the screen */
          width: 300px;
          min-width: unset;
          box-shadow: none;
        }
      }
    `
  )}
`;
